import { LocalizedLink } from "~/components/common/localized-link"
import React from 'react'

// Rough SVG approximation of Japan regions with text labels.
// In production, this would be a highly detailed path per prefecture.
const regions = [
  { id: 4, name: 'Hokkaido', path: 'M450 50 L480 30 L510 50 L500 100 L450 120 Z', labelX: 470, labelY: 75 },
  { id: 10, name: 'East Japan', path: 'M450 120 L500 100 L480 200 L430 250 L410 180 Z', labelX: 450, labelY: 170 },
  { id: 1, name: 'Tokyo', path: 'M430 250 L450 240 L460 260 L440 270 Z', labelX: 445, labelY: 258 },
  { id: 8, name: 'Kanagawa', path: 'M420 255 L440 270 L430 280 L410 265 Z', labelX: 425, labelY: 270 },
  { id: 5, name: 'Aichi', path: 'M380 280 L410 265 L400 300 L370 290 Z', labelX: 390, labelY: 285 },
  { id: 3, name: 'Kyoto', path: 'M350 280 L380 260 L370 290 L340 300 Z', labelX: 358, labelY: 283 },
  { id: 2, name: 'Osaka', path: 'M340 300 L370 290 L360 310 L330 315 Z', labelX: 348, labelY: 305 },
  { id: 7, name: 'Hyogo', path: 'M310 290 L350 280 L340 300 L300 310 Z', labelX: 325, labelY: 295 },
  { id: 11, name: 'West Japan', path: 'M250 300 L310 290 L300 320 L230 330 Z', labelX: 270, labelY: 310 },
  { id: 9, name: 'Kagawa', path: 'M290 325 L320 315 L310 335 L280 340 Z', labelX: 300, labelY: 330 },
  { id: 6, name: 'Fukuoka', path: 'M200 330 L230 330 L220 370 L190 360 Z', labelX: 210, labelY: 350 },
]

export function JapanMap({ t }: { t: any }) {
  return (
    <div className="relative w-full max-w-2xl mx-auto aspect-[4/3] p-4 md:p-8">
      <svg 
        viewBox="100 0 500 420" 
        className="w-full h-full drop-shadow-sm"
        fill="currentColor"
      >
        {/* Background glow effect */}
        <defs>
          <filter id="glow">
            <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
          <linearGradient id="regionGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="hsl(210 40% 85%)" />
            <stop offset="100%" stopColor="hsl(210 40% 78%)" />
          </linearGradient>
          <linearGradient id="regionGradientDark" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="hsl(215 25% 30%)" />
            <stop offset="100%" stopColor="hsl(215 25% 25%)" />
          </linearGradient>
        </defs>

        {regions.map((region) => (
          <LocalizedLink 
            key={region.id}
            to={`/regions/${region.id}`}
            className="group outline-none cursor-pointer"
          >
            <path
              d={region.path}
              className="fill-slate-200 dark:fill-slate-700 stroke-white dark:stroke-slate-900 stroke-[2.5] hover:fill-primary/80 dark:hover:fill-primary/60 transition-colors duration-200"
              filter="url(#glow)"
            />
            {/* Region label */}
            <text
              x={region.labelX}
              y={region.labelY}
              textAnchor="middle"
              paintOrder="stroke"
              strokeWidth={3.5}
              className="fill-slate-700 stroke-white text-[11px] font-semibold pointer-events-none select-none transition-colors duration-200 group-hover:fill-primary dark:fill-slate-100 dark:stroke-slate-900"
            >
              {t(`regions.${region.id}`)}
            </text>
          </LocalizedLink>
        ))}
      </svg>
    </div>
  )
}
